(function(){
    'use strict';
    //Rendo questo modulo sincrono restituendo un deferer per il rilascio esterno
    window.dcyAngular.internalDefine(function(){
            var dcyUtilsFactory 			= invokeAngularService('dcyUtilsFactory'),
	            $q 							= invokeAngularService('$q'),
	            deferred 					= $q.defer(),
	        	applicationInfo 			= window.dcyAngular.SESSION_DATA.data.applicationInfo,
	        	componentsJsTokanized 		= applicationInfo.jsToken  + applicationInfo.srcPath + applicationInfo.componentsPath,
	        	classesJsTokanized 			= applicationInfo.jsToken  + 'jsLib/classes/',
	        	componentsCssTokanized  	= applicationInfo.cssToken + applicationInfo.srcPath + applicationInfo.componentsPath,
	            sectionsJsTokanized  		= applicationInfo.jsToken  + applicationInfo.srcPath + applicationInfo.sectionsPath,
	        	templatesPathCssTokanized  	= applicationInfo.cssToken + applicationInfo.srcPath + applicationInfo.templatesPath,
	        	templatesPathJsTokanized  	= applicationInfo.jsToken  + applicationInfo.srcPath + applicationInfo.templatesPath,
	        	componentsVendorTokanized  	= applicationInfo.jsToken  + applicationInfo.vendorPath,

            	resourcesCss = [
            		componentsCssTokanized + 'loading_spinner/dcy_loading_spinner.css',
            		componentsCssTokanized + 'navigation/tree_nav/assets/css/tree_nav.css'
            	],
                resourcesJs =  [
                	classesJsTokanized 	  + 'data_managers/component_registry/component_registry_manager.class.es6.js',
                	/**### METADATA ### */
                	classesJsTokanized + 'metadata/cassiopea_types_enum.class.js',
                	//Navigations Core Components
                	componentsJsTokanized + 'navigation/navigation_manager.filters.js',
                	componentsJsTokanized + 'navigation/navigation_manager_utils.factory.js',
                	componentsJsTokanized + 'navigation/navigation_manager_status.factory.js',
                	componentsJsTokanized + 'navigation/tree_nav/tree_nav.directive.js',
                	/**### DATA MANAGERS ### */
                	classesJsTokanized + 'data_managers/loaders/loader_presets_enum.class.es6.js',
                	classesJsTokanized + 'data_managers/loaders/loaders_manager.class.es6.js',
                	componentsJsTokanized + 'loading_spinner/loader.class.es6.js',
                	componentsJsTokanized + 'loading_spinner/dcy_loading_spinner.directive.js',
                	templatesPathJsTokanized + 'ApplicationOrganizer/applicationOrganizer_BaseTMPL.res/application_organizer.factory.js',
                 ];


            dcyUtilsFactory.resolveDependencies(resourcesCss, '', function(){
            	dcyUtilsFactory.resolveDependencies(resourcesJs, '', function(){
            		deferred.resolve();
            	}, function(){
            		deferred.reject();
            	});
            });

        	return deferred.promise;
    });
}());